import defineComponent from 'flight';

function DetailsListUI() {
    this.defaultAttrs({
        action: '[data-details-list-toggle-action]'
    });

    this._expand = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        this.$node.toggleClass('view-item-details-list-item-expanded');
    };

    this.after('initialize', function () {
        this.on('click', {
            action: this._expand
        });
    });
}

module.exports = defineComponent.component(DetailsListUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/details-list-ui.js